module.exports = __webpack_public_path__ + "img/novi_predmet.ba83305e.svg";